import React, { useState, useEffect } from 'react';
import ScreenHeading from '../../../utils/ScreenHeading/ScreenHeading';
import ScrollService from '../../../utils/ScrollService';
import Animations from '../../../utils/Animations';

import WorkHistory from './WorkHistory/WorkHistory';
import ProgrammingLanguages from './ProgrammingLanguage/ProgrammingLanguages';
import Projects from './Projects/Projects.jsx';
import Education from './Education/Education';

import './Resume.css';
import "./Education/Education";
import "./WorkHistory/WorkHistory";
import "./ProgrammingLanguage/ProgrammingLanguages";
import "./Projects/Projects.jsx";


export default function Resume ( props )
{
  const [ education, setEducation ] = useState( true );
  const [ workHistory, setWorkHistory ] = useState( false );
  const [ progammingLanguage, setProgammingLanguage ] = useState( false );
  const [ projects, setProjects ] = useState( false );

  let fadeInScreenHandler = ( screen ) =>
  {
    if ( screen.fadeInScreen !== props.id )
      return;
    Animations.animations.fadeInScreen( props.id );
  };
  const fadeInSubscription = ScrollService.currentScreenFadeIn.subscribe( fadeInScreenHandler );

  useEffect( () =>
  {
    return () =>
    {
      fadeInSubscription.unsubscribe();
    };
  }, [ fadeInSubscription ] );

  function setAllFalse ()
  {
    setEducation( false );
    setWorkHistory( false );
    setProgammingLanguage( false );
    setProjects( false );
  }

  function changeState ( functionCalled, bool )
  {
    setAllFalse();
    functionCalled( bool );
  }


  return (
    <div>
      <div className='resume-outer-section d-flex flex-column fade-in' id={ props.id || "" }>

        <ScreenHeading title={ 'Resume' } subHeading={ 'My Formal Bio Details' } />
        {/* <span className='resume-heading-text'>Resume</span>
        <span className='resume-subheading-text'>My Formal Bio Details</span> */}

        {/* resume-new-section */ }
        <div className='resume-inner-section row'
          style={ { width: "70%", marginInline: "auto" } }>

          {/* Left Section */ }
          <div className='resume-left-section d-flex flex-row px-0 shadow-lg col-lg-4 col-md-4'>

            {/* Icons */ }
            <div className='d-flex flex-column bg-new text-white'>
              <span className='icons-span'>
                <i class="fa fa-graduation-cap"></i>
              </span>
              <span className='icons-span'>
                <i class="fa-solid fa-briefcase"></i>
              </span>
              <span className='icons-span'>
                <i class="fa-solid fa-laptop-code"></i>
              </span>
              <span className='icons-span'>
                <i class="fa-solid fa-list-check"></i>
              </span>
            </div>

            {/* Words to Icon */ }
            <div className='d-flex flex-column '>
              <span
                className={ education === false ? 'resume-option-items'
                  : 'selected resume-option-items' }
                onClick={ () => { changeState( setEducation, true ); } }>
                Education
              </span>
              <span
                className={ workHistory === false ? 'resume-option-items'
                  : 'selected resume-option-items' }
                onClick={ () => { changeState( setWorkHistory, true ); } }>
                Work
              </span>
              <span
                className={ progammingLanguage === false ? 'resume-option-items'
                  : 'selected resume-option-items' }
                onClick={ () => { changeState( setProgammingLanguage, true ); } }>
                Programming
              </span>
              <span
                className={ projects === false ? 'resume-option-items'
                  : 'selected resume-option-items' }
                onClick={ () => { changeState( setProjects, true ); } }>
                Projects
              </span>
            </div>
          </div>

          {/* Right Section */ }
          <div className='resume-right-section col-lg-8 col-md-8 col-sm-12 '>

            { education === true && <Education /> }
            { workHistory === true && <WorkHistory /> }
            { progammingLanguage === true && <ProgrammingLanguages /> }
            { projects === true && <Projects /> }


          </div>
        </div>
      </div>
    </div>
  );
}